import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Typography, Tooltip, IconButton } from '@material-tailwind/react';
import { styled } from '@mui/material/styles';
import { Dialog, ListItemText } from '@mui/material';
import MsgInputError from '../MsgInputError';
import { SquarePlus } from 'lucide-react';
import { useState } from 'react';
import CategoriasLinhas from '../CategoriasLinhas/CategoriasLinhas';
import { XMarkIcon } from '@heroicons/react/24/outline';

const StyledGroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 0,
  padding: '6px 10px',
  margin: 0,
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  zIndex: 1,
  fontSize: 13,
  textTransform: 'uppercase',
}));

const MarcasDeCompra = ({
  options,
  value,
  setValue,
  inputValue,
  setInputValue,
  register,
  errors,
}) => {
  const { onChange, name } = register('categoria', { required: true });
  const option = options.flatMap((produto) =>
    produto.categorias.map((categoria) => ({
      group: produto.nome,
      label: categoria.nome,
      id: categoria.id,
    }))
  );
  const [openCategoria, setOpenCategoria] = useState(false);

  const handleOpenCategoria = () => {
    setOpenCategoria(!openCategoria);
  };

  return (
    <div className="w-full flex-1 basis-1/2">
      <Typography
        variant="h6"
        color="black"
        className="mb-1 text-left font-medium dark:!text-darkText  flex items-center justify-between"
      >
        Categoria *
        <Tooltip content="Criar nova categoria">
          <SquarePlus
            className="dark:opacity-100 dark:text-darkText cursor-pointer"
            onClick={handleOpenCategoria}
          />
        </Tooltip>
      </Typography>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        style={{ textTransform: 'uppercase' }}
        options={option}
        groupBy={(option) => option.group}
        getOptionLabel={(option) => option.label.toUpperCase()}
        renderGroup={(params) => (
          <li key={params.key}>
            <StyledGroupHeader>{params.group}</StyledGroupHeader>
            {params.children}
          </li>
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <ListItemText
              primary={option.label}
              primaryTypographyProps={{
                sx: { textTransform: 'uppercase', color: 'black' },
              }}
            />
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Tipo de produto"
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 44, // Controla a altura do campo de input
              },
            }}
          />
        )}
        className="bg-white z-50  rounded-md"
      />
      {errors && <MsgInputError text={'Este campo é obrigatório'} />}
      <>
        <Dialog open={openCategoria} onClose={handleOpenCategoria}>
          <IconButton
            size="sm"
            variant="text"
            className="!absolute right-3.5 top-3.5"
            onClick={handleOpenCategoria}
          >
            <XMarkIcon className="h-4 w-4 stroke-2 dark:text-darkText" />
          </IconButton>
          <CategoriasLinhas title={'Criar Categoria'} />
        </Dialog>
      </>
    </div>
  );
};

export default MarcasDeCompra;
